import { BlockStack, Box, Grid, InlineStack, Pagination, SkeletonBodyText, SkeletonDisplayText } from '@shopify/polaris';
import React from 'react';

const ValueMappingModalSkelton = () => {
    return (
        <BlockStack gap="500">
            <BlockStack gap="0">
                <div className="custom-grid_header">
                    <Grid>
                        <Grid.Cell
                            columnSpan={{
                                xs: 3,
                                sm: 3,
                                md: 3,
                                lg: 6,
                                xl: 6,
                            }}>
                            <BlockStack gap="150">
                                <div style={{ width: '180px' }}>
                                    <SkeletonBodyText lines={1} />
                                </div>
                                <SkeletonDisplayText size="small" />
                            </BlockStack>
                        </Grid.Cell>
                        <Grid.Cell
                            columnSpan={{
                                xs: 3,
                                sm: 3,
                                md: 3,
                                lg: 6,
                                xl: 6,
                            }}>
                            <BlockStack gap="150">
                                <div style={{ width: '180px' }}>
                                    <SkeletonBodyText lines={1} />
                                </div>
                                <SkeletonDisplayText size="small" />
                            </BlockStack>
                        </Grid.Cell>
                    </Grid>
                </div>
                <div className="custom-grid__wrap">
                    {[1, 2, 3, 4, 5, 6, 7, 8].map((mapping: any) => {
                        return (
                            <Box paddingBlock="300" key={mapping}>
                                <InlineStack
                                    align="space-between"
                                    gap={'400'}
                                    blockAlign="center">
                                    <div
                                        style={{
                                            width: '100px',
                                        }}>
                                        {' '}
                                        <SkeletonBodyText lines={1} />
                                    </div>
                                    <div
                                        style={{
                                            width: '280px',
                                        }}>
                                        {' '}
                                        <SkeletonDisplayText size="small" />
                                    </div>
                                </InlineStack>
                            </Box>
                        );
                    })}
                    <Box paddingBlockStart="300">
                        <InlineStack align="center" gap="400">
                            <Pagination
                                label={
                                    <div className='value-modal-pagination__skelton'><SkeletonBodyText lines={1} /></div>
                                }
                                hasPrevious={false}
                                hasNext={false}
                            />
                        </InlineStack>
                    </Box>
                </div>
            </BlockStack>
        </BlockStack>
    );
};

export default ValueMappingModalSkelton;
